export enum ConditionLibraryFeature {
  HeaderText,
  FirstPageFooter,
  AdditionalTemplates,
  PageBreak,
  LetterHead,
  NumberingInclusion,
  DisableFirstPageHeader
}
